export const getIntegerSelectedOptions = (select: HTMLSelectElement) => {
    return [].filter.call(select.options, function (o: HTMLOptionElement) {
        return o.selected;
    }).map(function (o: HTMLOptionElement) {
        return parseInt(o.value);
    });
};